import { take, put, fork, select, takeEvery } from 'redux-saga/effects'
import { isEmpty, get, values } from 'lodash-es'
import queryString from 'query-string'

import {
  knobsPanelHeight,
  knobsPanelMobileHeight,
  headerMobileHeight,
  mobileBreakpoint,
  feedDescriptionHeight
} from '../util/settings'

import queryParser from '../util/queryParser'
import searchTagsFormatter from '../util/searchTagsFormatter'

import { LOCATION_CHANGE } from '../store/location'
import { requestPost, RECEIVE_POST } from './card'
import { emptyPicks, requestAccountPicks, RECEIVE_ACCOUNT_PICKS } from './pick'
import { makeGetFullUserByUsername, selectFeeds, selectFeedSections, selectCards } from './entities'
import { requestAdvancedSearchParameters } from './advancedSearch'
import { requestUserId, RECEIVE_PROFILE } from './profile'
import { setReferrerId, makeGetReferrerId } from './referrer'
import {
  requestCollections,
  requestSaved,
  requestPins,
  RECEIVE_CUSTOM_FEEDS,
  RECEIVE_ALL_PINS,
  RECEIVE_COLLECTIONS
} from './userContent'
import { resetSearch, requestSearch, RECEIVE_SEARCH, requestPreviousSearches } from './search'
import { requestTopComments, requestComments } from './comments'
import { requestFeedSections, RECEIVE_FEED_SECTIONS } from './feeds'
import { requestActivities } from './activities'
import { getFeedDescription } from '../components/FeedDescription/getFeedDescription'
import { setScrollHeight, toggleFeedsFilter } from './ui'
import {
  toDefault,
  setAllProps,
  // setLayoutType,
  requestDefaultViewSettings,
  PROFILE_FEED_NAME,
  HOME_FEED_NAME,
  VIEWSETTINGS_HIGHLIGHTS,
  VIEWSETTINGS_CARDS,
  VIEWSETTINGS_COLLECTIONS,
  VIEWSETTINGS_SAVED
} from './viewSettings'

export const selectLocations = getState => {
  return getState.routerLocations
}

function* changingLocationActivity(action) {
  const { pathname, search } = action.payload
  const segments = pathname.substr(1).split('/')
  const pastLocations = yield select(selectLocations)
  const lastLocation = pastLocations[pastLocations.length - 2]
  const lastSegments = lastLocation && lastLocation.pathname.substr(1).split('/')
  const paramsArray = location.search.replace('?', '').split('&')
  const lastParamsArray = lastLocation ? lastLocation.search.replace('?', '').split('&') : []
  const params = {}
  const lastParams = {}
  yield put(toggleFeedsFilter(false))
  paramsArray.forEach(i => {
    const [key, value] = i.split('=')
    params[key] = value
  })
  lastParamsArray.forEach(i => {
    const [key, value] = i.split('=')
    lastParams[key] = value
  })

  const getReferrerId = makeGetReferrerId()
  const oldRefId = yield select(getReferrerId)

  const currentRef = params.ref || (segments[0].startsWith('@') ? segments[0].replace('@', '') : null)
  const lastRef =
    lastParams.ref || (lastSegments && lastSegments[0].startsWith('@') ? lastSegments[0].replace('@', '') : null)

  speechSynthesis.cancel() // to make sure
  const getUser = makeGetFullUserByUsername()
  let user = yield select(getUser, params.ref)
  if (user.size) {
    yield put(requestActivities())
  }
  if (
    lastRef &&
    !currentRef &&
    !segments[0].includes('@') &&
    !(lastSegments[0] === 'picks' || lastSegments[0] === 'collections')
  ) {
    yield put(setReferrerId({ id: null, oldRefId }))
  }
  yield put(toDefault())
  if (segments[0] === 'collections' || segments[0] === 'picks') {
    let collectionThumbnails = params.thumbnail
    user = user || {}
    if (!user.get('id') && params.ref) {
      yield put(requestUserId(params.ref, []))
      while (!user.get('id')) {
        yield take(RECEIVE_PROFILE)
        user = yield select(getUser, params.ref)
      }
      yield put(requestPost(segments[1], { refId: user.get('id'), collectionThumbnails }))
      if (segments[0] === 'collections') {
        yield put(requestComments(segments[1]))
        yield take(RECEIVE_POST)
        const cards = yield select(selectCards)
        const card = cards.get(segments[1])
        const viewSettings = card.get('view_settings')
        const thumbnailType = viewSettings && viewSettings.get('thumbnail_type')
        const hiddenInfo = viewSettings && viewSettings.get('hidden_info')
        const removedInfo = viewSettings && viewSettings.get('removed_info')
        const layoutType = viewSettings && viewSettings.get('layout_type')
        yield put(
          setAllProps({ thumbnailType: params.thumbnail || thumbnailType, hiddenInfo, removedInfo, layoutType })
        )
      }
    } else {
      yield put(requestPost(segments[1], { refId: user.get('id'), collectionThumbnails }))
      if (segments[0] === 'collections') {
        yield put(requestComments(segments[1]))
        yield take(RECEIVE_POST)
        const cards = yield select(selectCards)
        const card = cards.get(segments[1])
        const viewSettings = card.get('view_settings')
        const thumbnailType = viewSettings && viewSettings.get('thumbnail_type')
        const hiddenInfo = viewSettings && viewSettings.get('hidden_info')
        const removedInfo = viewSettings && viewSettings.get('removed_info')
        const layoutType = viewSettings && viewSettings.get('layout_type')
        yield put(
          setAllProps({ thumbnailType: params.thumbnail || thumbnailType, hiddenInfo, removedInfo, layoutType })
        )
      }
    }
  }
  if (segments[0].startsWith('@')) {
    // defeault view options for Profile Home Tab
    const isMobile = window.innerWidth <= mobileBreakpoint
    const knobsPanel = isMobile ? knobsPanelMobileHeight : knobsPanelHeight
    yield put(setScrollHeight(knobsPanel))
    const getUser = makeGetFullUserByUsername()
    const username = segments[0].startsWith('@') ? segments[0].replace('@', '') : null
    let user = yield select(getUser, username)
    if (user.get('id') && user.get('username') === username) {
      yield put(requestFeedSections({ userId: user.get('id') }))
      yield put(requestPins({ userId: user.get('id'), limit: 1 }))
    } else {
      yield take(RECEIVE_PROFILE)
      user = yield select(getUser, username)
      yield put(requestFeedSections({ userId: user.get('id') }))
      yield put(requestPins({ userId: user.get('id'), limit: 1 }))
    }

    let ref
    let profile
    if (params.ref) {
      ref = yield select(getUser, params.ref)
    }
    if (!get(ref, 'id') && params.ref) {
      yield put(requestUserId(params.ref, []))
      profile = yield take(RECEIVE_PROFILE)
      ref = {
        id: profile.payload.data.result
      }
    }
    switch (segments[1]) {
      case 'highlights':
        yield put(requestDefaultViewSettings({ feedName: VIEWSETTINGS_HIGHLIGHTS }))
        if (isEmpty(user)) {
          yield put(requestUserId(username, ['picks'], get(ref, 'id', user.get('id')), true))
        } else {
          if (currentRef !== lastRef) {
            yield put(setReferrerId({ id: user.get('id'), oldRefId }))
          }
          yield put(requestPins({ id: user.get('id') }))
        }
        break
      case 'cards':
        yield put(requestDefaultViewSettings({ feedName: VIEWSETTINGS_CARDS }))
        if (isEmpty(user)) {
          yield put(requestUserId(username, ['picks'], get(ref, 'id', user.get('id')), true))
        } else {
          if (currentRef !== lastRef) {
            yield put(setReferrerId({ id: user.get('id'), oldRefId }))
          }
          yield put(requestAccountPicks(user.get('id'), null, { refId: get(ref, 'id', user.id) }))
          yield put(requestPins({ id: user.get('id'), feed: 'picks' }))
        }
        break
      case 'collections':
        yield put(requestDefaultViewSettings({ feedName: VIEWSETTINGS_COLLECTIONS }))
        if (isEmpty(user)) {
          yield put(requestUserId(username, ['collections'], get(ref, 'id', user.id), true))
        } else {
          if (currentRef !== lastRef) {
            yield put(setReferrerId({ id: user.get('id'), oldRefId }))
          }
          yield put(requestCollections({ id: user.get('id'), published: true }))
          yield put(
            requestPins({
              id: user.get('id'),
              feed: 'collections',
              collectionThumbnails: params.thumbnail || 'squared'
            })
          )
        }
        break
      case 'custom-feed': {
        if (currentRef !== lastRef) {
          yield put(setReferrerId({ id: user.get('id'), oldRefId }))
        }
        const _customFeedId = segments[2].split('----')[0]
        let feeds = yield select(selectFeeds)

        while (!feeds.get(_customFeedId)) {
          yield take([RECEIVE_PROFILE])
          feeds = yield select(selectFeeds)
        }
        const feed = feeds.get(_customFeedId)
        const object = feed ? feed.getIn(['query', 'object']) : null
        const viewSettings = feed.get('view_settings')
        const thumbnailType = viewSettings && viewSettings.get('thumbnail_type')
        const hiddenInfo = viewSettings && viewSettings.get('hidden_info')
        const removedInfo = viewSettings && viewSettings.get('removed_info')
        const layoutType = viewSettings && viewSettings.get('layout_type')
        yield put(setAllProps({ thumbnailType, hiddenInfo, removedInfo, layoutType }))
        yield put(
          requestSearch({
            ...(object
              ? object
                  .set('tags', searchTagsFormatter(object.toJS()))
                  .set('mediaTags', searchTagsFormatter(object.toJS(), true))
                  .delete('limit')
                  .toJS()
              : {}),
            collectionThumbnails: thumbnailType,
            referrer_id: get(feed, 'query.object.referrer_id') || user.get('id')
          })
        )
        break
      }
      case 'advanced-feed': {
        if (currentRef !== lastRef) {
          yield put(setReferrerId({ id: user.get('id'), oldRefId }))
        }
        const advancedFeedId = segments[2].split('----')[0]
        let feeds = yield select(selectFeeds)

        while (!feeds.get(advancedFeedId)) {
          yield take([RECEIVE_PROFILE])
          feeds = yield select(selectFeeds)
        }
        const feed = feeds.get(advancedFeedId)
        const object = feed ? feed.getIn(['query', 'object']) : null
        const viewSettings = feed.get('view_settings')
        const thumbnailType = viewSettings && viewSettings.get('thumbnail_type')
        const hiddenInfo = viewSettings && viewSettings.get('hidden_info')
        const removedInfo = viewSettings && viewSettings.get('removed_info')
        const layoutType = viewSettings && viewSettings.get('layout_type')
        yield put(setAllProps({ thumbnailType, hiddenInfo, removedInfo, layoutType }))
        yield put(
          requestSearch({
            ...(object
              ? object
                  .set('tags', searchTagsFormatter(object.toJS()))
                  .set('mediaTags', searchTagsFormatter(object.toJS(), true))
                  .delete('limit')
                  .toJS()
              : {}),
            collectionThumbnails: thumbnailType,
            referrer_id: get(feed, 'query.object.referrer_id') || user.get('id')
          })
        )
        break
      }
      case 'collection-feed': {
        const collectionId = segments[2]
        yield put(requestPost(collectionId, { refId: get(ref, 'id', user.get('id')) }))
        break
      }
      default:
        const feedsNormalized = yield take(RECEIVE_FEED_SECTIONS)
        yield put(requestDefaultViewSettings({ feedName: PROFILE_FEED_NAME }))
        if (isEmpty(user)) {
          yield put(requestUserId(username, ['home'], get(ref, 'id', user.id)))
        } else {
          if (currentRef !== lastRef) {
            yield put(setReferrerId({ id: user.get('id'), oldRefId }))
          }
          yield put(requestPins({ id: user.get('id'), collectionThumbnails: 'squared' }))
          yield take(RECEIVE_ALL_PINS)
        }
        yield put(requestCollections({ id: user.get('id'), published: true, limit: 6 }))
        yield take(RECEIVE_COLLECTIONS)
        yield put(requestAccountPicks(user.get('id'), null, { refId: user.get('id'), limit: 6 }))
        yield take(RECEIVE_ACCOUNT_PICKS)
        const { feeds } = feedsNormalized.payload.data.entities
        let a = 0
        for (let i in feeds) {
          const feed = feeds[i]
          const { object } = feed.query
          if (!feed.url.includes('/collections/')) {
            if (object.sortBy === 'likes') {
              object.flag = 'likes'
            }
            for (let i in object) {
              if (i.includes('tags[')) {
                object.tags = object.tags || []
                object.tags.push(object[i])
              }
            }
            for (let i in object) {
              if (i.includes('mediaTags[')) {
                object.mediaTags = object.mediaTags || []
                object.mediaTags.push(object[i])
              }
            }
            if (a) {
              yield take(RECEIVE_SEARCH)
            }
            a++
            yield put(requestSearch({ ...object, limit: 6, referrer_id: user.get('id') }))
          }
        }
    }
  }

  if (segments[0] === 'home') {
    yield put(requestFeedSections())
    const feedsNormalized = yield take(RECEIVE_FEED_SECTIONS)
    const { feeds, feedSections } = feedsNormalized.payload.data.entities
    const feedIds = get(values(feedSections).sort((a, b) => a.position - b.position)[0], 'feeds', [])
    for (let i = 0; i < feedIds.length; i++) {
      const { object } = feeds[feedIds[i]].query

      if (feeds[feedIds[i]].people_usernames && feeds[feedIds[i]].people_usernames.length) {
        const userNames = feeds[feedIds[i]].people_usernames.split(',').map(item => {
          return item.trim()
        })

        object.userNames = userNames
      }
      if (object.sortBy === 'likes') {
        object.flag = 'likes'
      }
      for (let i in object) {
        if (i.includes('tags[')) {
          object.tags = object.tags || []
          object.tags.push(object[i])
        }
        if (i.includes('mediaTags[')) {
          object.mediaTags = object.mediaTags || []
          object.mediaTags.push(object[i])
        }
      }
      // yield put(setLayoutType('gallery'))
      yield put(requestSearch({ ...object, limit: 6 }))
    }
    yield put(requestDefaultViewSettings({ feedName: HOME_FEED_NAME }))
  }
  if (segments[0] === '') {
    yield put(requestFeedSections())
    yield put(requestDefaultViewSettings({ feedName: VIEWSETTINGS_SAVED }))
    const getCurrentUser = makeGetFullUserByUsername()
    let user = yield select(getCurrentUser)

    if (user.get('id') && user.get('username')) {
      let ref
      let profile
      if (params.ref) {
        ref = yield select(getCurrentUser, params.ref)
      }
      if (!get(ref, 'id') && params.ref) {
        yield put(requestUserId(params.ref, []))
        profile = yield take(RECEIVE_PROFILE)
        ref = {
          id: profile.payload.data.result
        }
      }

      yield put(requestSaved({ id: user.id, published: true }))

      const feedsNormalized = yield take(RECEIVE_FEED_SECTIONS)
      const { feeds, feedSections } = feedsNormalized.payload.data.entities
      const feedIds = get(values(feedSections).sort((a, b) => a.position < b.position)[0], 'feeds', [])
      for (let i = 0; i < feedIds.length; i++) {
        const { object } = feeds[feedIds[i]].query
        if (object.sortBy === 'likes') {
          object.flag = 'likes'
        }
        for (let i in object) {
          if (i.includes('tags[')) {
            object.tags = object.tags || []
            object.tags.push(object[i])
          }
          if (i.includes('mediaTags[')) {
            object.mediaTags = object.mediaTags || []
            object.mediaTags.push(object[i])
          }
        }
        yield put(requestSearch({ ...object, limit: 3 }))
      }
    }
  }
  if (segments[0] === 'custom-feed') {
    let customFeedId = segments[1] && segments[1].split('----')[0]
    const customFeedName = segments[1] && segments[1].split('----')[1]
    yield put(requestFeedSections())
    yield take([RECEIVE_CUSTOM_FEEDS, RECEIVE_FEED_SECTIONS])
    yield put(
      requestAdvancedSearchParameters({
        feed_id: customFeedId
      })
    )

    let feeds = yield select(selectFeeds)
    feeds = feeds.filter(i => i.get('home') === true)
    if (!customFeedId && !feeds.size) {
      const publicFeeds = feeds.filter(i => !i.get('private')).sort((a, b) => a.get('position') - b.get('position'))
      if (publicFeeds.size) {
        customFeedId = publicFeeds.getIn([0, 'id'])
      }
    }
    if (!feeds.get(customFeedId)) {
      yield put(requestFeedSections())
      yield take([RECEIVE_CUSTOM_FEEDS, RECEIVE_FEED_SECTIONS])
      feeds = yield select(selectFeeds)
      if (!customFeedId) {
        const feedSections = yield select(selectFeedSections)
        const feedSection = feedSections.sort((a, b) => a.position - b.position)[0]
        customFeedId = feeds
          .filter(i => !i.get('private') && feedSection.get('feeds').includes(i.get('id')))
          .sort((a, b) => a.get('position') - b.get('position'))
          .getIn([0, 'id'])
      }
    }

    const description = getFeedDescription({ feeds, feedId: customFeedId })
    const isMobile = window.innerWidth <= mobileBreakpoint
    const headerHeight = isMobile ? headerMobileHeight : 0
    const knobsPanel = isMobile ? knobsPanelMobileHeight : knobsPanelHeight
    const scrollHeightValue = description
      ? knobsPanel + headerHeight + feedDescriptionHeight
      : knobsPanel + headerHeight
    yield put(setScrollHeight(scrollHeightValue))
    const feed = feeds.get(customFeedId)
    const object = feed && feed.getIn(['query', 'object']).toJS()

    object.tags = searchTagsFormatter(object)
    object.mediaTags = searchTagsFormatter(object, true)
    if (object.sortBy === 'likes') {
      object.flag = 'likes'
    }
    if (feed.get('people_usernames') && feed.get('people_usernames').length) {
      const userNames = feed
        .get('people_usernames')
        .split(',')
        .map(item => {
          return item.trim()
        })

      object.userNames = userNames
    }
    delete object.limit

    const viewSettings = feed.get('view_settings')
    const thumbnailType = viewSettings && viewSettings.get('thumbnail_type')
    const hiddenInfo = viewSettings && viewSettings.get('hidden_info')
    const removedInfo = viewSettings && viewSettings.get('removed_info')
    const layoutType = viewSettings && viewSettings.get('layout_type')
    yield put(setAllProps({ thumbnailType, hiddenInfo, removedInfo, layoutType }))
    yield put(
      requestSearch(
        customFeedName && customFeedName.toLowerCase() === 'from-the-editor'
          ? { flag: 'fromTheEditor' }
          : { ...object, collectionThumbnails: thumbnailType }
      )
    )
  }
  if (
    (lastSegments && lastSegments[1] === 'cards') ||
    (((lastSegments && lastSegments[0].startsWith('@')) || segments[0] === 'profile') &&
      !(lastSegments && lastSegments[1]))
  ) {
    yield put(emptyPicks())
  }

  if (['search'].includes(segments[0])) {
    yield put(requestPreviousSearches())
  }

  if (['search', 'feed'].includes(segments[0])) {
    yield put(requestFeedSections())
    yield put(resetSearch())
    const parsedSearch = queryString.parse(search, { arrayFormat: 'index' })
    if (parsedSearch.sortBy === 'likes') {
      parsedSearch.flag = 'likes'
    }
    if (segments[1] !== 'top-comments') {
      yield put(
        requestSearch({
          ...(segments[0] === 'feed' && segments[1] === 'popular' && { flag: 'popularPicks' }),
          ...(segments[0] === 'feed' && segments[1] === 'collections' && { type: 'collections' }),
          ...(segments[0] === 'search' && parsedSearch)
        })
      )
    } else {
      yield put(requestTopComments({}))
    }
  }
}

function* changingLocationActivitySaga() {
  yield takeEvery(LOCATION_CHANGE, changingLocationActivity)
}

function* initialActivity() {
  yield put({
    type: LOCATION_CHANGE,
    payload: { pathname: window.location.pathname, action: 'PUSH', search: window.location.search, hash: '' }
  })
  const ref = queryParser(location.search, 'ref')
  if (ref) {
    yield put(requestUserId(ref, [], null, true))
  }
}

// runs only once on app initialize. more convenient than store.dispatch
function* initialActivitySaga() {
  yield fork(initialActivity)
}

export const sagas = [changingLocationActivitySaga, initialActivitySaga]

export default function routerLocations(state = [], action) {
  switch (action.type) {
    case LOCATION_CHANGE: {
      return [...state, action.payload]
    }
    default:
      return state
  }
}
